import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { AppSettingService } from '../services/app-setting.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityService {


  constructor(private http: HttpClient) { }

  getAvailabilityList(): Observable<any> {
    return this.http
      .get(AppSettingService.getAvailabilitiesUri ).pipe(catchError(this.error));

  }
  // test(): Observable<any> {
  //   return this.http
  //     .get(AppSettingService.getAvailabilitiesUri).pipe(catchError(this.error));

  // }

  getAvailability(providerStatusId:any): Observable<any> {
    return this.http
      .get(AppSettingService.getAvailabilityUri +"?Id="+providerStatusId).pipe(catchError(this.error));

  }
  add(model:any): Observable<any> {
    return this.http
      .post(AppSettingService.addAvailabilityUri ,model).pipe(catchError(this.error));

  }

  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(error);
    return throwError({ error: error.error, status: error.status });
  }
}